export const THIRDWEB_CONTRACT_ID = "Soulbound"
export const THIRDWEB_PUBLISHER = "0x3C2F0873bE11B0d3840fd8279A2994e66b76E498"